/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>帮我约她</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true"  ref="formInline" :model="formInline"  class="user-search">

        <el-form-item prop="accountId" label="申请人UID:">
        <el-input maxlength=11   clearable  v-model="formInline.accountId" placeholder="输入申请人UID"></el-input>
      </el-form-item>


      <el-form-item label="申请人昵称:" prop="nickName">
        <el-input maxlength="10" clearable v-model="formInline.nickName" placeholder="输入申请人昵称"></el-input>
      </el-form-item>

      <el-form-item prop="phone" label="申请人手机:">
        <el-input maxlength=11 clearable v-model="formInline.phone" placeholder="输入申请人手机"></el-input>
      </el-form-item>

      <el-form-item prop="sex" label="申请人性别:">
        <el-select v-model="formInline.sex" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="platformType" label="申请平台 ">
        <el-select v-model="formInline.platformType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option v-for="item in PlatformTypeOptions" :key="item.value" :value="item.value"
                     :label="item.label"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="beginApplyTime" label="申请时间:">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
                          v-model="formInline.beginApplyTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endApplyTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime"
                            placeholder="选择日期" v-model="formInline.endApplyTime"
                            style="width: 100%;"></el-date-picker>

          </el-form-item>

        </el-col>
      </el-form-item>

      <el-form-item prop="toAccountId" label="帮约对象UID:">
        <el-input maxlength=11 clearable v-model="formInline.toAccountId" placeholder="输入帮约对象UID"></el-input>
      </el-form-item>

      <el-form-item label="帮约对象昵称:" prop="toNickName">
        <el-input maxlength="10" clearable v-model="formInline.toNickName" placeholder="输入帮约对象昵称"></el-input>
      </el-form-item>

      <el-form-item prop="toPhone" label="帮约对象手机:">
        <el-input maxlength=11 clearable v-model="formInline.toPhone" placeholder="输入帮约对象手机"></el-input>
      </el-form-item>


      <div style=" float: right; margin-right: 50px; margin-bottom: 50px; ">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-delete"
                   @click="resetForm('formInline')">重置
        </el-button>
        <!-- <el-button  type="success" @click="resetForm('formInline')">重置</el-button> -->

      </div>
    </el-form>

    <!--列表-->
    <el-table id="educe-table" ref="multipleTable" @selection-change="handleSelectionChange" stripe :data="listData"
              highlight-current-row v-loading="loading"

              @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
              style="width: 100%; font-size: 18px;">
      <el-table-column @select-all="selectall" align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="accountId" label="申请人UID" align="center" width="150">
        <template slot-scope="scope">
          <span style="font-size: 30px; font-weight: 600; color: #8F5BE7;">{{ scope.row.accountId }}</span><br>
          <img v-if="scope.row.isJoinVipClub==1" style="width: 90px; height: 30px; margin-top: 10px;"
               src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/a3c71c1d-165d-4688-9db4-0f63541cab90.png"
               alt="">
          <br><span v-if="scope.row.isMember==1" style="width: 90px; height: 30px; margin-top: 10px; color: red; font-size: 12px" >线上VIP</span>
          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
        </template>
      </el-table-column>

      <el-table-column prop="headIcon" align="center" label="申请人头像" width="150">
        <template slot-scope="scope">
          <img style="width: 120px; height: 120px;" :src="scope.row.headIcon" alt="">

        </template>
      </el-table-column>


      <el-table-column prop="image" label="申请人信息" width="250">
        <template slot-scope="scope">
          <span>昵称:{{ scope.row.nickName }}</span><br>
          <span>年龄:{{ scope.row.age }} {{ scope.row.age ? '岁' : '' }}/ {{ scope.row.sex == 1 ? '男' : '女' }}</span><br>
          <div style="font-size: 18px;">学历: <span v-if="scope.row.education==7">博士后</span>
            <span v-if="scope.row.education==6">博士</span>
            <span v-if="scope.row.education==5">硕士</span>
            <span v-if="scope.row.education==4">本科</span>
            <span v-if="scope.row.education==3">大专</span>
            <span v-if="scope.row.education==2">中专</span>
            <span v-if="scope.row.education==1">中专以下</span></div>
          <!-- <span>学历:{{scope.row.educationDesc}}</span><br> -->
          <span>月收入:{{ scope.row.monthlyIncomeDesc }}</span><br>
          <span>居住地:{{ scope.row.address }}</span><br>
        </template>
      </el-table-column>


      <el-table-column prop="phone" align="center" label="申请人手机" width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.phone, userifom|mobileStr||'' }}</div>
        </template>

      </el-table-column>
      <el-table-column align="center" prop="status" label="账号状态" width="150">
        <template slot-scope="scope">
          <span style="color: #3399FF;" v-if="scope.row.accountStatus==1">正常</span>
          <span style="color: darkgoldenrod;" v-if="scope.row.accountStatus==2">注销中</span>
          <span style="color: red;" v-if="scope.row.accountStatus==3||scope.row.accountStatus==null">已注销</span>
        </template>
      </el-table-column>
      <el-table-column prop="applyTimeMills" align="center" label="申请时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.applyTimeMills|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="platformTypeDesc" align="center" label="平台" width="150">
      </el-table-column>
      <el-table-column prop="remark" align="center" label="申请描述" width="350">
      </el-table-column>
      <el-table-column prop="toAccountId" label="帮约对象UID" align="center" width="150">
        <template slot-scope="scope">
          <span style="font-size: 30px; font-weight: 600; color: #8F5BE7;">{{ scope.row.toAccountId }}</span><br>
          <img v-if="scope.row.toIsJoinVipClub==1" style="width: 90px; height: 30px; margin-top: 10px;"
               src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/a3c71c1d-165d-4688-9db4-0f63541cab90.png"
               alt="">

        </template>
      </el-table-column>


      <el-table-column prop="toHeadIcon" align="center" label="帮约对象头像" width="150">
        <template slot-scope="scope">
          <img style="width: 120px; height: 120px;" :src="scope.row.toHeadIcon" alt="">

        </template>
      </el-table-column>

      <el-table-column prop="image" label="帮约对象信息" width="250">
        <template slot-scope="scope">
          <span>昵称:{{ scope.row.toNickName }}</span><br>
          <span>年龄:{{ scope.row.toAge }} {{ scope.row.toAge ? '岁' : '' }} /{{ scope.row.toSex == 1 ? '男' : '女' }}</span><br>
          <div style="font-size: 18px;">学历: <span v-if="scope.row.toEducation==7">博士后</span>
            <span v-if="scope.row.toEducation==6">博士</span>
            <span v-if="scope.row.toEducation==5">硕士</span>
            <span v-if="scope.row.toEducation==4">本科</span>
            <span v-if="scope.row.toEducation==3">大专</span>
            <span v-if="scope.row.toEducation==2">中专</span>
            <span v-if="scope.row.toEducation==1">中专以下</span></div>
          <!-- <span>学历:{{scope.row.toEducation}}</span><br> -->
          <span>月收入:{{ scope.row.toMonthlyIncomeDesc }}</span><br>
          <span>居住地:{{ scope.row.toAddress }}</span><br>
        </template>
      </el-table-column>

      <el-table-column prop="toPhone" label="帮约对象手机" width="150">
      </el-table-column>


      <!-- <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
                @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <div style="margin-top: 20px; position: fixed; bottom: 50px; left: 300px;"
         v-if="roleId.roleId==1||roleId.roleId==2">
      <el-button v-if="ifShowbar==1" @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button v-if="ifShowbar==2" @click="selectallsif(listData)" type="primary">反选</el-button>
      <!-- <el-button @click="selectalls(listData)" type="primary">{{ addtitle }}</el-button> -->
      <el-button @click="imporList" type="success">导出数据</el-button>
      <el-button @click="exporList" type="success">导入CRM</el-button>

    </div>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="部门名称" prop="deptName">
          <el-input v-model="editForm.deptName" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input v-model="editForm.deptNo" auto-complete="off" placeholder="请输入部门代码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >

      <span>确定导出用户数据？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="falseDialogVisible">取 消</el-button>
    <el-button type="primary" @click="dialogVisiblexel">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisiblCrm"
      width="30%"
    >
      <span>确定导入CMR？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="falseDialogVisibles">取 消</el-button>
    <el-button type="primary" @click="dialogVisiblexelss">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {deptList, deptSave, deptDelete} from '../../api/userMG'
import Axios from 'axios'
import {login} from "../../api"
import Vue from 'vue'
import { homeData } from '../../request/home'

import {mobileStr}from "../../utils/util"
import Pagination from '../../components/Pagination'
import {PlatformTypeOptions} from "../../enums/userEnum";

export default {
  computed: {
    PlatformTypeOptions() {
      return PlatformTypeOptions
    }
  },
  data() {
    return {
      addtitle: '全选',
      userifom: "",
      dialogVisible: false,
      ssoServer: "",
      dialogVisiblCrm: false,
      dialogVisibles: false,
      options123: [],
      options1234123: [],
      forlist: [],
      importListsss: '',
      ifShowbar: 1,
      adder: "",

      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      options: [
        {
          value: 0,
          label: '不限'
        },
        {
          value: 1,
          label: '中专以下'
        }, {
          value: 2,
          label: '中专'
        }, {
          value: 3,
          label: '大专'
        }, {
          value: 4,
          label: '本科'
        }, {
          value: 5,
          label: '硕士'
        }, {
          value: 6,
          label: '博士'
        }, {
          value: 7,
          label: '博士后'
        }],
      source: [{
        value: 1,
        label: '网站注册'

      }, {
        value: 2,
        label: '人工录入'

      }, {
        value: 3,
        label: '资源导入'

        },{
          value: 4,
          label: '相亲活动'

        },{
          value: 5,
          label: '手机来电'

        },{
          value: 6,
          label: '表单填写'

        },{
          value: 7,
          label: '到店咨询'

        }],
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },

      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        platformType:"",

        accountId:'',
        beginApplyTime:"",
        endApplyTime:"",
        nickName:"",
        phone:"",
        sex:"",
        toAccountId:'',
        toNickName:'',
        toPhone:'',
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      roleId:"",
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.roleId=JSON.parse(localStorage.getItem('userlist'))
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    let tokenId= localStorage.getItem('tokenId');
    this.adder =tokenId



    // this.getdata(this.formInline)
  },
   mounted(){
    this.userifom= localStorage.getItem('userifom');
    this.formLIst()
    // this.getAddress()
    // this.getAddresss()
    // this.ongetAddress()


   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    ongetAddress(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/source-config/getList',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        console.log(res);
        this.forlist =res.data.data
        // this.options123 = res.data.data

      })

    },

    falseDialogVisible(){
      // this.importList=[]
      this.dialogVisible=false

    },
    falseDialogVisibles(){
      // this.importList=[]
      this.dialogVisiblCrm=false

    },
    dialogVisiblexel(){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        Axios({
          method: 'post',

          url: this.ssoServer + '/api/pull-strings/export',
          headers: {
            tokenId: this.adder
          },
          data: {
            ids: this.importListsss,
            searchType: 1
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=UTF-8'})
          link.href = window.URL.createObjectURL(blob)
          const filename = '帮我约她列表'
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
        this.ifShowbar = 1
        this.importList = []
        this.formLIst()
        this.dialogVisible = false
        loading.close();
      }, 500);


    },

    dialogVisiblexelss() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        Axios({
          method: 'post',

          url: this.ssoServer + '/api/pull-strings/export',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importListsss,
            searchType: 1
          },

        }).then(res => {
          if (res.data.code == 0) {
            this.$message({
              type: 'success',
              message: '导入成功'
            })
            this.ifShowbar = 1
            this.importList = []
            this.formLIst()
            this.dialogVisiblCrm = false
          }


        })

        loading.close();
      }, 500);


    },


    selectall(val) {
      // console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importListsss = data
        console.log(this.importList);

      })

      // this.importList
    // console.log(val);
    },


    getAddress(){

      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',

        headers:{
          tokenId:this.adder
        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },

    getAddresss(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e){
      console.log("change1", e);
      if(e.length === 1){
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if(e.length === 2){
        this.formInline.registerAddress=e[1];
      }
    },


    selectallsif(){
      this.ifShowbar=1
      this.$refs.multipleTable.clearSelection();//清除全选
      this.importList=[]
    },

    selectalls(rows) {


      if (rows) {
        let data =[]
        rows.forEach((item)=>{
        data.push(item.id)
        this.importListsss =data
        console.log(this.importList);

      })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        // console.log('1212112');
        this.importList=[]
        this.$refs.multipleTable.clearSelection();//清除全选
      }
       this.ifShowbar=2


    },

              onChange(e){

                this.formInline.registerAddress=e[1]
                  // console.log( this.formInline.registerAddress);


              },
              onChanges(e){
                console.log(e);
                let adder =e[1]
                this.formInline.registerIpAddress=adder
                // this.formInline.registerIpAddress=e[1]
                  // console.log( this.formInline.registerAddress);
              },
    // selectall(val){

    //   let data =[]
    //   val.forEach((item)=>{
    //     data.push(item.id)
    //     this.importList =data
    //     console.log(this.importList);

    //   })

    //   // this.importList
    // console.log(val);
    // },
    handleSelectionChange(val) {
        this.importList = val;
      },
    // 导出数据
    imporList(){

      if(this.importList.length==0){
        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      }else{
        this.dialogVisible=true
      }

    },
    exporList(){

if(this.importList.length==0){
  this.$message({
    type: 'warning',
    message: '请选择要导入的数据'
  })
  return

}else{
  this.dialogVisiblCrm=true
}

},

    select(selection, row){

      let data =[]
      // this.importList=''
      selection.forEach((item)=>{
        data.push(item.id)
        this.importListsss =data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
  //  this.formInline =''
        this.$refs[formInline].resetFields();
      },


    formLIst(){

      // let accountListReqVO= this.formInline
      Axios({
  method: 'get',

  url: this.ssoServer+'/api/pull-strings/getList',
  headers:{
          tokenId:this.adder
        },
  params:this.formInline


}).then(res=>{
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==500){
          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }
  this.listData =res.data.data.list

      this.pageparm.currentPage = this.formInline.current
      this.pageparm.pageSize = this.formInline.size
      this.pageparm.total = res.data.data.total
  console.log(res);
})

    },
    formatData(row, column, cellValue, index){

		//把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		//最终返回 s 就可以了
		var s =	new Date(cellValue).toLocaleString();
	    return s;

		  // 测试参数含义：不知道参数是什么含义的就打印出来
		  // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		  // console.log(column)  	//拿到列的信息
		  // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		  // console.log(index)     //拿到索引
	    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            addUser: null,
            editUser: null,
            addTime: 1521062371000,
            editTime: 1526700200000,
            deptId: 2,
            deptName: 'XX分公司',
            deptNo: '1',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1521063247000,
            editTime: 1526652291000,
            deptId: 3,
            deptName: '上海测试',
            deptNo: '02',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526349555000,
            editTime: 1526349565000,
            deptId: 12,
            deptName: '1',
            deptNo: '11',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526373178000,
            editTime: 1526373178000,
            deptId: 13,
            deptName: '5',
            deptNo: '5',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526453107000,
            editTime: 1526453107000,
            deptId: 17,
            deptName: 'v',
            deptNo: 'v',
            parentId: 1
          }
        ]
      }
      this.loading = false

      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)
    },
    handleSizeChange(e){
      // reru console.log(e.pageSize);
      this.formInline.size =e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
    // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current=1
      // if(this.formInline.beginAge<18){
      //   this.$message({
      //             type: 'warning',
      //             message: '年龄不能小于18'
      //           })
      //           return

      // }else if(this.formInline.endAge>80){
      //   this.$message({
      //             type: 'warning',
      //             message: '年龄不能大于80'
      //           })
      //           return
      // }

this.formLIst()

      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/Mentor/appointment.vue